import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";  //Router をインポート
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>  {/* ここでアプリ全体を Router で包む */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();